import { subMinutes } from "date-fns";

export function ConvertDate(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid date");
  }
  var _smonth = date.getMonth() + 1;
  var sdates =
    date.getFullYear() +
    "-" +
    ("0" + _smonth).slice(-2) +
    "-" +
    ("0" + date.getUTCDate()).slice(-2);
  var stime =
    ("0" + date.getUTCHours()).slice(-2) +
    ":" +
    ("0" + date.getUTCMinutes()).slice(-2) +
    ":" +
    ("0" + date.getUTCSeconds()).slice(-2);
  var finalDate = sdates + " " + stime;
  return finalDate;
}

export function ConvertDateTwo(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid date");
  }
  var _smonth = date.getUTCMonth() + 1;
  var sdates =
    date.getUTCFullYear() +
    "_" +
    ("0" + _smonth).slice(-2) +
    "_" +
    ("0" + date.getUTCDate()).slice(-2);
  var stime =
    ("0" + date.getUTCHours()).slice(-2) +
    "_" +
    ("0" + date.getUTCMinutes()).slice(-2) +
    "_" +
    ("0" + date.getUTCSeconds()).slice(-2);
  var finalDate = sdates + "_" + stime;
  return finalDate.toString();
}

export function ConvertDateThree(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid date");
  }
  var sdate =
    ("0" + date.getUTCDate()).slice(-2) +
    "_" +
    ("0" + (date.getUTCMonth() + 1)).slice(-2) +
    "_" +
    date.getUTCFullYear();
  var stime =
    ("0" + date.getUTCHours()).slice(-2) +
    "_" +
    ("0" + date.getUTCMinutes()).slice(-2) +
    "_" +
    ("0" + date.getUTCSeconds()).slice(-2);
  var formattedDate = sdate + "_" + stime;
  return formattedDate;
}

export function ConvertDateToUTC(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid date");
  }
  var _smonth = date.getUTCMonth() + 1;
  var sdates =
    date.getUTCFullYear() +
    "-" +
    ("0" + _smonth).slice(-2) +
    "-" +
    ("0" + date.getUTCDate()).slice(-2);
  var stime =
    ("0" + date.getUTCHours()).slice(-2) +
    ":" +
    ("0" + date.getUTCMinutes()).slice(-2) +
    ":" +
    ("0" + date.getUTCSeconds()).slice(-2);
  var finalDate = sdates + " " + stime;
  return finalDate;
}

export function parseTimeIntoDate(time) {
  let dt = time.split(":");
  let newDate = new Date();
  newDate.setHours(dt[0]);
  newDate.setMinutes(dt[1]);
  return newDate;
}

export function validateTime(fromTime, toTime) {
  if (fromTime.getTime() > toTime.getTime()) {
    return false;
  }
  return true;
}

export const to12HrFormat = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid date");
  }

  const hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year} ${formattedHours}:${minutes} ${period}`;
};

export const frontDateConverter = (d) => {
  let first = d.split(" ");
  let arr = first[0].split("-");
  let temp = `${arr[2]}-${arr[1]}-${arr[0]} ${first[1]}`;
  return temp;
};

export const onlyDateConverter = (d) => {
  return d.split("-")[2] + "-" + d.split("-")[1] + "-" + d.split("-")[0];
};

export const formatDatetoDay = (d) => {
  const daydummy = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const date = new Date(d); // Directly parse the input date string
  if (isNaN(date)) {
    throw new Error("Invalid date"); // Handle invalid date input
  }
  const dayIndex = date.getDay(); // Get the day index (0 = Sunday, 1 = Monday, etc.)
  return daydummy[dayIndex]; // Return the corresponding day name
};

export function AllDateFormat(date) {
  var sdate =
    ("0" + date.getUTCDate()).slice(-2) +
    "-" +
    ("0" + (date.getUTCMonth() + 1)).slice(-2) +
    "-" +
    date.getUTCFullYear();
  var stime =
    ("0" + date.getUTCHours()).slice(-2) +
    ":" +
    ("0" + date.getUTCMinutes()).slice(-2) +
    ":" +
    ("0" + date.getUTCSeconds()).slice(-2);
  var formattedDate = sdate + " " + stime;
  return formattedDate;
}

export const multiTimeZoneHelper = (difference) => {
  if (difference > 0) {
    difference = -1 * difference;
  } else {
    difference = Math.abs(difference);
  }
  let current_date = new Date();
  let now_utc_date = new Date(current_date.toUTCString().slice(0, -4));
  let converted_date = subMinutes(now_utc_date, difference);
  return converted_date;
};

export const formatJSDateObject = (dateStr) => {
  if (dateStr == null || dateStr == undefined) {
    return null;
  }
  const date = new Date(dateStr);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

export const formatJSDateInDDMMYYYY = (dateStr) => {
  if (dateStr == null || dateStr == undefined) {
    return null;
  }
  const date = new Date(dateStr);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

export const formatJSDateObjectUWEB = (dateStr) => {
  if (dateStr == null || dateStr == undefined) {
    return null;
  }
  const date = new Date(dateStr);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  const formattedDate = `${year}-${day}-${month} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

export const replaceTimeToDate = (date, timeString) => {
  const [hours, minutes, seconds] = timeString.split("_").map(Number);
  let newDate = new Date(date);
  newDate.setHours(hours);
  newDate.setMinutes(minutes);
  newDate.setSeconds(seconds);
  newDate.setMilliseconds(0);
  return newDate;
};

export const subtractMinutes = (date, minutesToSubtract) => {
  let newDate = new Date(date);
  newDate.setMinutes(newDate.getMinutes() - minutesToSubtract);
  return newDate;
};

export const addMinutesToDate = (date, minutesToAdd) => {
    // Create a new Date object to avoid mutating the original
    let newDate = new Date(date);
  
    // Subtract minutes
    newDate.setMinutes(newDate.getMinutes() + minutesToAdd);
  
    return newDate;
  };

export const getMinutesDifference = (date1, date2) => {
  const diffInMs = date2.getMinutes() - date1.getMinutes();
  return diffInMs;
};

export const getUTCDate = (currentDate) => {
  let year = currentDate.getUTCFullYear();
  let month = String(currentDate.getUTCMonth() + 1).padStart(2, "0");
  let day = String(currentDate.getUTCDate()).padStart(2, "0");
  let hours = String(currentDate.getUTCHours()).padStart(2, "0");
  let minutes = String(currentDate.getUTCMinutes()).padStart(2, "0");
  let seconds = String(currentDate.getUTCSeconds()).padStart(2, "0");
  let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};
